module.exports = __webpack_public_path__ + "static/media/questa-sans-regular.729ba82c.woff2";